var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Tablo") } },
        [
          _c(
            "a-select",
            {
              on: { change: _vm.handleTableChange },
              model: {
                value: _vm.localValue.table,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "table", $$v)
                },
                expression: "localValue.table",
              },
            },
            _vm._l(_vm.tables, function (table) {
              return _c(
                "a-select-option",
                { key: table._id, attrs: { value: table._id } },
                [
                  _vm._v(
                    "\n                " + _vm._s(table.name) + "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Bağlantı Türü") } },
        [
          _c(
            "a-select",
            {
              on: { change: _vm.handleConnectionTypeChange },
              model: {
                value: _vm.localValue.connectionType,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "connectionType", $$v)
                },
                expression: "localValue.connectionType",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "_id" } }, [
                _vm._v("ID"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "field" } }, [
                _vm._v(_vm._s(_vm.$t("Alan"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localValue.connectionType === "field"
        ? _c(
            "a-form-item",
            { attrs: { label: _vm.$t("Alan") } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.localValue.field,
                    callback: function ($$v) {
                      _vm.$set(_vm.localValue, "field", $$v)
                    },
                    expression: "localValue.field",
                  },
                },
                _vm._l(
                  _vm.getTableFields(_vm.localValue.table),
                  function (field) {
                    return _c(
                      "a-select-option",
                      { key: field._id, attrs: { value: field._id } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(field.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }
                ),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }